import {FormGridField} from "../../../../../utils/forms/components/FormGrid";
import _ from "lodash";
import * as Yup from "yup";

export const mrChampionFields = _.memoize(():FormGridField[] => [
    {
        name: "prize_parameters_group",
        fieldType: "group",
        fieldOptions: {
            id: "prizeParametersGroup",
            inputType: "group",
            label: "Prize Parameters"
        },
        formSpacing: false,
        columnClass: "col-12"
    },
    {
        name: "min_players",
        fieldType: "number",
        fieldOptions: {
            id: "minPlayers",
            placeholder: "Min. Players",
            inputType: "integer",
            label: "Min. Players"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4",
        formSpacing: false,
        validation: Yup.number()
            .required("Field is required.")
            .integer("Must be an integer")
    },
    {
        name: "initial_value",
        fieldType: "number",
        fieldOptions: {
            id: "initialValue",
            placeholder: "Initial Value",
            inputType: "integer",
            label: "Initial Value"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4",
        formSpacing: false,
        validation: Yup.number()
            .required("Field is required.")
            .integer("Must be an integer")
            .min(0, "Value must be >= 0.")
            .max(42949672.95, "Max. 42949672,95 characters.")
            .when(`max_value`, (value, schema) => {
                return value
                    ? schema.max(value, `Must be <= than Maximum Value.`)
                    : schema;
            })
    },
    {
        name: "max_value",
        fieldType: "number",
        fieldOptions: {
            id: "max_value",
            placeholder: "Insert Max Value",
            inputType: "integer",
            label: "Maximum Value"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4",
        formSpacing: false,
        validation: Yup.number()
            .required("Field is required.")
            .integer("Must be an integer")
            .min(0, "Value must be >= 0.")
            .max(42949672.95, "Max. 42949672,95 characters.")
    },
    {
        name: "contribution",
        fieldType: "number",
        fieldOptions: {
            id: "contrib",
            placeholder: "Insert Contribution",
            inputType: "number",
            label: "Contribution",
            decimal: true
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 percentage",
        formSpacing: false,
        validation: Yup.number()
            .required("Field is required.")
            .min(0.01, "Value must be >= 0,01.")
            .max(10, `Must be <= than 10`)
    },
    {
        name: "min_sort",
        fieldType: "number",
        fieldOptions: {
            id: "minSort",
            placeholder: "Min. Sort",
            inputType: "number",
            label: "Min. Sort",
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4",
        formSpacing: false,
        validation: Yup.number()
            .integer("Must be an integer")
            .required("Field is required.")
            .min(1, "Value must be >= 1.")
            .when(`max_sort`, (value, schema) => {
                return value
                    ? schema.max(value, `Must be <= than Max. Sort.`)
                    : schema;
            })
    },
    {
        name: "max_sort",
        fieldType: "number",
        fieldOptions: {
            id: "maxSort",
            placeholder: "Max. Sort",
            inputType: "number",
            label: "Max. Sort",
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4",
        formSpacing: false,
        validation: Yup.number()
            .required("Field is required.")
            .integer("Must be an integer")
            .when(`max_value`, (value, schema) => {
                return value
                    ? schema.max(value, `Must be <= than Maximum Value.`)
                    : schema;
            })
    },
    {
        name: "time_parameters_group",
        fieldType: "group",
        fieldOptions: {
            id: "timeParametersGroup",
            inputType: "group",
            label: "Time Parameters"
        },
        formSpacing: false,
        columnClass: "col-12"
    },
    {
        name: "time_continue_eligible_bonus",
        fieldType: "number",
        fieldOptions: {
            id: "timeContinueEligibleBonus",
            placeholder: "Time Continue Eligible Bonus",
            inputType: "number",
            label: "Time Continue Eligible Bonus"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 time",
        formSpacing: false,
        validation: Yup.number()
            .integer("Must be an integer")
            .required("Field is required.")
            .min(0, "Value must be >= 0.")
            .max(255, "Max. 255 characters.")
    },
    {
        name: "time_continue_eligible_game",
        fieldType: "number",
        fieldOptions: {
            id: "timeContinueEligibleGame",
            placeholder: "Time Continue Eligible Game",
            inputType: "number",
            label: "Time Continue Eligible Game"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 time",
        formSpacing: false,
        validation: Yup.number()
            .integer("Must be an integer")
            .required("Field is required.")
            .min(0, "Value must be >= 0.")
            .max(255, "Max. 255 characters.")
    },
    {
        name: "time_continue_eligible_extra",
        fieldType: "number",
        fieldOptions: {
            id: "timeContinueEligibleExtra",
            placeholder: "Time Continue Eligible Extra",
            inputType: "number",
            label: "Time Continue Eligible Extra"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 time",
        formSpacing: false,
        validation: Yup.number()
            .integer("Must be an integer")
            .required("Field is required.")
            .min(0, "Value must be >= 0.")
            .max(255, "Max. 255 characters.")
    },
    {
        name: "notice_period",
        fieldType: "number",
        fieldOptions: {
            id: "noticePeriod",
            placeholder: "Notice Period",
            inputType: "number",
            label: "Notice Period"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 time",
        formSpacing: false,
        validation: Yup.number()
            .integer("Must be an integer")
            .required("Field is required.")
            .min(0, "Value must be > 0.")
    },
    {
        name: "count_down_period",
        fieldType: "number",
        fieldOptions: {
            id: "countDownPeriod",
            placeholder: "Countdown Period",
            inputType: "number",
            label: "Countdown Period"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 time",
        formSpacing: false,
        validation: Yup.number()
            .integer("Must be an integer")
            .required("Field is required.")
            .min(0, "Value must be > 0.")
    },
    {
        name: "security_parameters_group",
        fieldType: "group",
        fieldOptions: {
            id: "securityParametersGroup",
            inputType: "group",
            label: "Security Parameters"
        },
        formSpacing: false,
        columnClass: "col-12"
    },
    {
        name: "weight_coin_in",
        fieldType: "number",
        fieldOptions: {
            id: "weightCoinIn",
            placeholder: "Weight Coin In",
            inputType: "number",
            label: "Weight Coin In"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4",
        formSpacing: false,
        validation: Yup.number()
            .integer("Must be an integer")
            .required("Field is required.")
    },
    {
        name: "percentage_terminal",
        fieldType: "number",
        fieldOptions: {
            id: "percentageTerminal",
            placeholder: "Percentage Terminal",
            inputType: "number",
            label: "Percentage Terminal"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 percentage",
        formSpacing: false,
        validation: Yup.number()
            .integer("Must be an integer")
            .required("Field is required.")
    },
    {
        name: "weight_total_bonus_win",
        fieldType: "number",
        fieldOptions: {
            id: "weightTotalBonusWin",
            placeholder: "Weight Total Bonus Win",
            inputType: "number",
            label: "Weight Total Bonus Win"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4",
        formSpacing: false,
        validation: Yup.number()
            .integer("Must be an integer")
            .required("Field is required.")
    },
    {
        name: "hunter_draw_no_win",
        fieldType: "number",
        fieldOptions: {
            id: "hunterDrawNoWin",
            placeholder: "Hunter Draw No Win",
            inputType: "number",
            label: "Hunter Draw No Win"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4",
        formSpacing: false,
        validation: Yup.number()
            .integer("Must be an integer")
            .required("Field is required.")
    },
    {
        name: "notice_period",
        fieldType: "number",
        fieldOptions: {
            id: "noticePeriod",
            placeholder: "Notice Period",
            inputType: "number",
            label: "Notice Period"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4",
        formSpacing: false,
        validation: Yup.number()
            .integer("Must be an integer")
            .required("Field is required.")
    },
    {
        name: "count_down_period",
        fieldType: "number",
        fieldOptions: {
            id: "countDownPeriod",
            placeholder: "Countdown Period",
            inputType: "number",
            label: "Countdown Period"
        },
        columnClass: "col-xs-12 col-sm-12 col-md-6 col-lg-4 col-xl-4",
        formSpacing: false,
        validation: Yup.number()
            .integer("Must be an integer")
            .required("Field is required.")
    }
])